import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';

const getEndPointUrl = () => '/rest/greenhopper/1.0/rapidviewconfig/boardLocation';

const putNewLocation$ = (data: string) => {
	const options = {
		method: 'PUT',
		body: JSON.stringify(data),
	};
	return fetchJson$(getEndPointUrl(), options);
};

export default putNewLocation$;
